module.exports = "<li class=\"lpview_tab_button tab_button\" title=\"{{tooltip}}\" tooltip-position=\"top\" tooltip-align=\"left\">{{title}}</li>";